<template>
  <icon-base :width="12" :height="7">
    <path stroke="currentColor" stroke-linejoin="bevel"
          d="M.2 3.5h11M7.85.4a11 11 0 003.55 3.1 11 11 0 00-3.55 3.1"/>
  </icon-base>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import IconBase from '@/vue/icons/IconBase.vue'

export default defineComponent({
  name: 'IconArrowAlt',
  components: {
    IconBase,
  },
})
</script>
